export default function filterOperatorCodesIfExistsInPostalOperators(
  operatorCodes,
  postalOperators,
) {
  const result = [];
  if (!postalOperators || postalOperators.length === 0) {
    return [...operatorCodes];
  }

  const addIfExists = (operatorCode) => {
    if (operatorCodes.includes(operatorCode)) {
      result.push(operatorCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];
    addIfExists(postalOperator.value);
  }

  return result;
}
